import { createSlice } from "@reduxjs/toolkit";

const loadCartFromStorage = () => {
  try {
    const stored = localStorage.getItem("bhogCart");
    if (stored) return JSON.parse(stored);
  } catch (err) {
    console.error("Failed to load bhogCart from storage", err);
  }
  return [];
};

const saveCartToStorage = (items) => {
  try {
    localStorage.setItem("bhogCart", JSON.stringify(items));
  } catch (err) {
    console.error("Failed to save bhogCart to storage", err);
  }
};

const initialState = {
  items: loadCartFromStorage(), // Array of { id, tierIndex }
};

const bhogCartSlice = createSlice({
  name: "bhogCart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { id, tierIndex = 0 } = action.payload;
      const existingItem = state.items.find((item) => item.id === id);
      if (!existingItem) {
        state.items.push({ id, tierIndex });
        saveCartToStorage(state.items);
      }
    },
    removeFromCart: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter((item) => item.id !== id);
      saveCartToStorage(state.items);
    },
    updateTier: (state, action) => {
      const { id, tierIndex } = action.payload;
      const existingItem = state.items.find((item) => item.id === id);
      if (existingItem) {
        existingItem.tierIndex = tierIndex;
        saveCartToStorage(state.items);
      }
    },
    clearCart: (state) => {
      state.items = [];
      saveCartToStorage(state.items);
    },
  },
});

export const { addToCart, removeFromCart, updateTier, clearCart } =
  bhogCartSlice.actions;
export default bhogCartSlice.reducer;
